import { CommonModule } from '@angular/common';
import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TaggingOptions, UiKitModule } from '@serviceplan/ui-kit';
import {
  accessAsset,
  anyAsset,
  AssetUIModel,
  CanPipe,
  ClientCoreModule,
  ClientEnvironment,
  CommonUtilityLib,
  ENVIRONMENT,
  FieldType,
  PROMPTS,
  StepperGroupModel,
  ValueListsService,
} from '@thehubz/client/core';
import { UserAgencyClientBrandModel, UserAgencyClientModel, UserAgencyModel, UserInfo } from '@thehubz/client/data-access-api';
import { CustomClients } from '@thehubz/shared/branding';
import { filter, Subscription } from 'rxjs';
import { AssetCommonService } from '../../../services/asset-common.service';
import { productionDetailsStepperConfigs } from '../../asset-upload/stepper-config/asset-settings-stepper.constants';

@Component({
  selector: 'thehubz-asset-production-details',
  templateUrl: './asset-production-details.component.html',
  styleUrls: ['./asset-production-details.component.scss'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatIconModule, MatFormFieldModule, MatInputModule, ClientCoreModule, UiKitModule],
})
export class AssetProductionDetailsComponent implements OnInit, OnDestroy {
  @Input() asset!: AssetUIModel;
  assetInfoObject!: StepperGroupModel;
  assetInfo!: AssetUIModel;
  assetDataSubjectSubscription: Subscription | undefined;

  readonly brandingKey = this.env.brandingKey;
  readonly CustomClients = CustomClients;
  FieldType = FieldType;
  editFlag = false;

  agencies!: UserAgencyModel[];
  companies!: UserAgencyClientModel[];
  brands!: UserAgencyClientBrandModel[];

  mediumFields: string[] = [];
  agencySelected!: { name: string; _id: string };
  clientSelected!: { name: string; _id: string };
  brandSelected!: { name: string; _id: string };
  todayDate = new Date();
  AccessAsset = accessAsset;
  AnyAsset = anyAsset;
  taggingOptions: TaggingOptions = {
    roles: ['global.library', 'asset.update'],
  };
  taggedUser!: UserInfo[]; // tagged user list
  descriptionText!: string; // sp-editor description text

  minPublishDate = new Date();

  textIsRequired = PROMPTS.TEXT.IS_REQUIRED;

  constructor(
    @Inject(ENVIRONMENT) private env: ClientEnvironment,
    private _formBuilder: UntypedFormBuilder,
    protected valueListsService: ValueListsService,
    protected assetCommonService: AssetCommonService,
    private commonUtilityLib: CommonUtilityLib,
    private canPipe: CanPipe,
  ) {}

  ngOnInit(): void {
    this.assetInfoObject = productionDetailsStepperConfigs();
    this.assetDataSubjectSubscription = this.assetCommonService.assetDataSubject$
      .pipe(filter((asset) => !this.commonUtilityLib.isEmptyObject(asset)))
      .subscribe((asset) => {
        if (asset) {
          this.assetInfo = asset;
        }
      });
  }

  ngOnDestroy(): void {
    if (this.assetDataSubjectSubscription) this.assetDataSubjectSubscription.unsubscribe();
  }
}
